import React, { useEffect, useState } from 'react';
import { Worlds } from '../../api/client';
import { World } from '../../types';
import { Icon } from '../ui/Icon';
import { Section } from '../ui/primitives';

/** Top-down map render (generated when the world shuts down). */
const MapTab: React.FC<{ world: World }> = ({ world }) => {
  const [state, setState] = useState<'loading' | 'ok' | 'missing'>('loading');
  const [nonce, setNonce] = useState(0);
  const src = `${Worlds.mapRenderUrl(world.id)}${nonce ? `?t=${nonce}` : ''}`;

  useEffect(() => setState('loading'), [world.id, nonce]);

  return (
    <Section
      title="World map"
      blurb="A top-down render is produced each time the world shuts down."
      wide
      actions={
        <>
          <button type="button" className="btn btn--sm" onClick={() => setNonce(Date.now())}>
            <Icon name="refresh" size={12} /> Reload
          </button>
          {state === 'ok' && (
            <a className="btn btn--sm" href={src} download={`${world.name.replace(/[^\w.-]+/g, '_')}-map.png`}>
              <Icon name="download" size={12} /> .png
            </a>
          )}
        </>
      }
    >
      {state === 'missing' ? (
        <div className="map-ph">
          <div>
            <Icon name="map" size={34} style={{ opacity: 0.5, marginBottom: 10 }} />
            <b>No map render yet</b>
            <span>The map of {world.name} is generated the next time the world shuts down.</span>
          </div>
        </div>
      ) : (
        <div className="map-img" style={state === 'loading' ? { minHeight: 240, alignItems: 'center' } : undefined}>
          {state === 'loading' && <span className="spin" style={{ position: 'absolute' }} />}
          <img
            key={src}
            src={src}
            alt={`Map render of ${world.name}`}
            style={{ opacity: state === 'ok' ? 1 : 0 }}
            onLoad={() => setState('ok')}
            onError={() => setState('missing')}
          />
        </div>
      )}
    </Section>
  );
};

export default MapTab;
